import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import heroImg from "../assets/images/vision-hero.jpg";    // e.g., the stylized "tiny doctors" vector
import visionDetailImg from "../assets/images/vision.jpg"; // e.g., the skin layers illustration

function Vision() {
  return (
    <div className="vision-page">
      {/* Hero Banner */}
      <section
        className="vision-hero text-center d-flex align-items-center justify-content-center"
        style={{
          height: "50vh",
          background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${heroImg}) center/cover no-repeat`,
        }}
      >
        <h1 className="fw-bold display-4 text-white" data-aos="fade-down">
          Our Vision
        </h1>
      </section>

      {/* Vision Statement + Image */}
      <Container className="py-5">
        <Row className="align-items-center">
          <Col md={6} data-aos="fade-right" className="mb-4 mb-md-0">
            <Card className="shadow border-0">
              <Card.Body>
                <h2 className="fw-bold mb-3">Shaping the Future of Skin Health</h2>
                <p className="fs-5">
                  “To revolutionize skin care by leveraging data-driven technology,
                  empowering individuals worldwide to take proactive control of their
                  skin health and connect with dermatology experts seamlessly.”
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} data-aos="fade-left" className="text-center">
            <img
              src={visionDetailImg}
              alt="Dermatology Vision"
              className="img-fluid rounded shadow"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Vision;
